import { RouteId } from "../../../Routes";
import { ZensoryModule } from "../../../ZensoryModule";
import { AnalyticMainEventName } from "../../API/AnalyticsApi";
import { User, UserLicense, UserLicenseFull } from "../../Data/Models/app";
import { isNullOrEmpty } from "../../Data/Util/util";
import { Platform } from "../../Data/constants";
import { getConfiguration } from "../../Util/ConfigHelper";
import { LOGGER, LogLevel } from "../../Util/Logger";
import { getEmailDomain } from "../../Util/AuthHelper";
import { DOMAIN_REDEEM_CODES } from "./DomainRedeemCodeMapping";

export async function checkUserLicenses(
    user: User,
    licenses: UserLicense[]
) {
    if (!user) {
        console.error("checkUserLicenses: user is null");
        return;
    }

    if (isNullOrEmpty(licenses) || licenses.length === 0) {
        licenses = await ZensoryModule.getLicenses().getUserLicense(
            user.userId
        );
    }

    if (licenses && licenses.length === 0) {
        const config = getConfiguration();
        const userEmail = user.email;
        let redeemCode: string | null = null;

        // Priority 1: Check if user's email domain has a specific redeem code configured
        if (userEmail && !isNullOrEmpty(userEmail)) {
            const emailDomain = getEmailDomain(userEmail);
            if (emailDomain && DOMAIN_REDEEM_CODES[emailDomain]) {
                redeemCode = DOMAIN_REDEEM_CODES[emailDomain];
                LOGGER.log(LogLevel.DEBUG, `Using domain-specific redeem code ${redeemCode} for ${emailDomain} domain (prioritized over config.autoRedeemCode)`);
            }
        }

        // Priority 2: For other users, use config.autoRedeemCode if available
        if (!redeemCode && !isNullOrEmpty(config.autoRedeemCode)) {
            redeemCode = config.autoRedeemCode;
            LOGGER.log(LogLevel.DEBUG, `Using config.autoRedeemCode: ${redeemCode}`);
        }

        // Redeem the code if we have one
        if (redeemCode) {
            try {
                const licenses = await ZensoryModule.getLicenses().redeemCode(
                    user.userId,
                    redeemCode,
                    config.platformOverride || Platform.Web
                );

                // track the event
                const license: UserLicenseFull = licenses[0] as UserLicenseFull; 
                ZensoryModule.getAnalytics().trackEvent(
                    AnalyticMainEventName.OnAutoRedeemCode,
                    {
                        subscriptionId: license.licenseId,
                        licenseId: license.licenseId,
                        companyId: license.companyId,
                        companyLicenseId: license.companyLicenseId,
                    }
                );
                LOGGER.log(LogLevel.DEBUG, `autoRedeemCode success, licenses=${JSON.stringify(licenses)}`);

                // call this function again to check if the user now has a license
                checkUserLicenses(user, licenses);
                return;

            } catch (error) {
                LOGGER.log(LogLevel.ERROR, `Error with autoRedeemCode, error=${error}`);

                // fall through to navigation to the subscribe page
            }
        }

        if (config.useLicenses) {
            // else navigate to the subscribe page for the user to purchase a license themselves
            ZensoryModule.getNavigationHandler().navigate(
                window,
                RouteId.Subscribe
            );
        }
    }
}